<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :outlined="outlined"
  />
</template>

<script>
export default {
  name: 'AdsTextField',
  props: {
    outlined: {
      type: Boolean,
      default: true   // override the default value 'false' in v-text-field
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/ads.scss';

.v-application .error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep div.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep label.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep button.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep i.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}
</style>
